module.exports = __webpack_public_path__ + "img/img-DIV-logo.a512ffd7.png";